//  /home/clement/compta-app/client/src/components/Facturation/Vente/Avoirs/CreerAvoir.js
import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { createAvoir } from '../../../../api/avoirApi';

const CreerAvoir = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    factureId: '',
    montant: '',
    motif: '',
    date: new Date().toISOString().split('T')[0],
  });
  const [factures, setFactures] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Exemple de chargement des factures (à adapter selon ton API)
  useEffect(() => {
    const fetchFactures = async () => {
      try {
        const response = await fetch('/api/factures-vente');
        const data = await response.json();
        setFactures(data);
      } catch (err) {
        console.error("Erreur lors du chargement des factures:", err);
      }
    };
    fetchFactures();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await createAvoir(formData);
      navigate('/avoirs');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Créer un avoir
      </Typography>
      {error && <Typography color="error">{error}</Typography>}
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal">
          <InputLabel>Facture associée</InputLabel>
          <Select
            name="factureId"
            value={formData.factureId}
            onChange={handleChange}
            required
          >
            {factures.map((facture) => (
              <MenuItem key={facture.id} value={facture.id}>
                {facture.numero} - {facture.clientNom}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          fullWidth
          margin="normal"
          label="Montant (€)"
          type="number"
          name="montant"
          value={formData.montant}
          onChange={handleChange}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Motif"
          name="motif"
          value={formData.motif}
          onChange={handleChange}
          multiline
          rows={4}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Date"
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
          required
        />
        <Box sx={{ mt: 2 }}>
          <Button type="submit" variant="contained" color="primary" disabled={loading}>
            {loading ? 'Enregistrement...' : 'Enregistrer'}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default CreerAvoir;
